<!-- @format -->

@for (responsibilityInfo of visibleResponsibilityInfos$ | async; track responsibilityInfo) {
  <sis-responsibility-info
    [responsibilityInfo]="responsibilityInfo"
    [showInactiveResponsibilities]="showInactiveResponsibilities"
    [showResponsibilityValidityPeriod]="showResponsibilityValidityPeriod">
  </sis-responsibility-info>
}
